import { Select } from "antd";
import React from "react";

const filterOption = [
    { value: 0, label: "All" },
    { value: 1, label: "Live agent transaction" },
    { value: 2, label: "Self Check-In" },
    { value: 3, label: "Pickup" },
];

export const ReceiptFilterSelect = ({ handleSelectChange, filterValue }) => {
    return (
        <Select
            id="sent-receipt"
            style={{ margin: "10px 0" }}
            defaultValue={filterValue}
            allowClear={false}
            onChange={handleSelectChange}
            options={filterOption}
        ></Select>
    );
};
